module.exports = __webpack_public_path__ + "img/feature_buy_bonus_id.33a0ca63.png";